module.exports = __webpack_public_path__ + "img/pickup.8b275ec0.jpg";